import { useTranslation } from 'react-i18next'
import { useTheme } from '../theme/ThemeProvider'
import type { ThemeMode } from '../theme/ThemeProvider'

const ORDER: ThemeMode[] = ['light', 'dark', 'system']

const ICONS: Record<ThemeMode, JSX.Element> = {
  light: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2m0 16v2M4.9 4.9l1.4 1.4m11.4 11.4 1.4 1.4M2 12h2m16 0h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
    </svg>
  ),
  dark: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z" />
    </svg>
  ),
  system: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M8 21h8m-4-4v4" />
    </svg>
  ),
}

/** 浅色 → 深色 → 跟随系统 循环切换 */
export function ThemeToggle() {
  const { t } = useTranslation()
  const { mode, setMode } = useTheme()

  const next = ORDER[(ORDER.indexOf(mode) + 1) % ORDER.length]
  const label = t(`theme.${mode}`)

  return (
    <button
      type="button"
      className="icon-btn"
      title={`${label} → ${t(`theme.${next}`)}`}
      aria-label={`${label}，${t(`theme.${next}`)}`}
      onClick={() => setMode(next)}
    >
      {ICONS[mode]}
    </button>
  )
}
